/* eslint-disable */
import React from 'react'
import styled from 'styled-components'
import { useTranslation } from "react-i18next"

const AboutSidebarStyle = styled.menu`
  padding: 0;
  margin: 0;
  width: 100%;
  display: flex;
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    width: 100%;
    display: flex;
    flex-direction: column;
    border: solid 1px #dcdcdc;
    > li {
      margin: 0;
      padding: 0;
      cursor: pointer;
      display: flex;
      width: 100%;
        justify-content: space-between;
        align-items: center;
        padding: 10px 24px;
        width: 100%;
        display: flex;
        text-decoration: none;
        background: #fff;
        font-family: 'Open Sans', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #191919;
        transition: all 0.3s ease-in;
        path:last-child {
          fill: #ff7400;
          transition: all 0.3s ease-in;
        }
        &:hover {
          color: #ff7400;
        }
        &.active {
          background: linear-gradient(to left, #ff9700, #ff7400);
          color: #fff;
          transition: all 0.3s ease-in;
          path:last-child {
            transition: all 0.3s ease-in;
            fill: #fff;
          }
        }
      
    }
  }
`

const ArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="17"
      viewBox="0 0 7 17"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M-9-6h24v24H-9z" />
        <path
          fillRule="nonzero"
          d="M1.238 0l5.17 5.805L7 6.5l-.592.695L1.238 13 0 11.61 4.55 6.5 0 1.39z"
        />
      </g>
    </svg>
  )
}

const scrollToFunction = (target) => {
  let targetOffset = document.getElementById(target).offsetTop - 85;
  window.scrollTo(0, targetOffset);
  document.getElementById(target).click();
}

const SidebarSyaratUmum = () => {
  const { t } = useTranslation()
  const DataSidebar = [
    {
      id: 'syarat-umum1',
      title: t('pageSyaratUmum.part1'),
      targetScroll: 'syarat-umum-1'
    },
    {
      id: 'syarat-umum2',
      title: t('pageSyaratUmum.part3'),
      targetScroll: 'syarat-umum-2'
    },
    {
      id: 'syarat-umum3',
      title: t('pageSyaratUmum.part5'),
      targetScroll: 'syarat-umum-3'
    },
    {
      id: 'syarat-umum4',
      title: t('pageSyaratUmum.part7'),
      targetScroll: 'syarat-umum-4'
    },
    {
      id: 'syarat-umum5',
      title: t('pageSyaratUmum.part9'),
      targetScroll: 'syarat-umum-5'
    },
    {
      id: 'syarat-umum6',
      title: t('pageSyaratUmum.part11'),
      targetScroll: 'syarat-umum-6'
    },
    {
      id: 'syarat-umum7',
      title: t('pageSyaratUmum.part13'),
      targetScroll: 'syarat-umum-7'
    },
    {
      id: 'syarat-umum8',
      title: t('pageSyaratUmum.part15'),
      targetScroll: 'syarat-umum-8'
    },
    {
      id: 'syarat-umum9',
      title: t('pageSyaratUmum.part17'),
      targetScroll: 'syarat-umum-9'
    },
    {
      id: 'syarat-umum10',
      title: t('pageSyaratUmum.part19'),
      targetScroll: 'syarat-umum-10'
    },
    {
      id: 'syarat-umum11',
      title: t('pageSyaratUmum.part21'),
      targetScroll: 'syarat-umum-11'
    },
    {
      id: 'syarat-umum12',
      title: t('pageSyaratUmum.part23'),
      targetScroll: 'syarat-umum-12'
    }
  ]
  return (
    <AboutSidebarStyle>
      <ul>
        {DataSidebar.map((value, index) => {
          return (
            <li onClick={() => scrollToFunction(value.targetScroll)} key={`privary-title-${index}`}>
              {value.title}
              {/* <ArrowIcon></ArrowIcon> */}
            </li>
          )
        })}
      </ul>
    </AboutSidebarStyle>
  )
}

export default SidebarSyaratUmum
